import React, { useState } from "react";
import {
  Paper,
  Grid,
  Divider,
  Typography,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import { Draggable } from "react-beautiful-dnd";
import { CustomAvatar } from "../../components/CustomAvatar";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { Actions } from "../../core/redux/ducks/article";
import { useDispatch } from "react-redux";
import { ConfirmModal } from "./ConfirmModal";

export const ArticleCard = ({ index, article, onClick }) => {
  const [modalConfirmState, setModalState] = useState({
    open: false,
    article: {},
  });
  const classes = useStyles();
  const dispatch = useDispatch();
  const deleteArticle = () => Actions.deleteArticle(dispatch, article.id);
  return (
    <>
      <Draggable index={index} draggableId={`${article.id}`}>
        {(provided, snapshot) => {
          return (
            <Paper
              className={classes.root}
              {...provided.dragHandleProps}
              {...provided.draggableProps}
              ref={provided.innerRef}
            >
              <Grid
                container
                direction="row"
                alignItems="center"
                style={{ height: "100%" }}
              >
                <Grid item md={11} onClick={onClick} style={{ height: "100%" }}>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    className={classes.container}
                  >
                    <Grid item md={3}>
                      <Grid container direction="row" alignItems="center">
                        <CustomAvatar size="sm" user={article.owner} />
                        <Typography
                          variant="caption"
                          className={classes.text}
                        >{`by ${article.owner.firstName} ${
                          article.owner.lastName || ""
                        }`}</Typography>
                      </Grid>
                    </Grid>
                    <Divider orientation="vertical" />
                    <Grid item md={5} className={classes.title}>
                      <Typography variant="body2" className={classes.text}>
                        {article.name}
                      </Typography>
                    </Grid>
                    <Divider orientation="vertical" />
                    <Grid item md={3}>
                      <Typography className={classes.text} variant="body2">
                        {new Date(article.updatedAt).toLocaleDateString(
                          "de-DE"
                        )}
                      </Typography>
                    </Grid>
                    <Divider orientation="vertical" />
                  </Grid>
                </Grid>
                <Grid item className={classes.deleteItem}>
                  <IconButton
                    size="small"
                    onClick={() => setModalState({ open: true, article })}
                  >
                    <DeleteOutlineIcon className={classes.deleteIcon} />
                  </IconButton>
                </Grid>
              </Grid>
            </Paper>
          );
        }}
      </Draggable>
      <ConfirmModal
        show={modalConfirmState.open}
        onHide={() => setModalState({ open: false, article: {} })}
        articleName={modalConfirmState.article.name}
        deleteArticle={(event) => {
          event.preventDefault();
          deleteArticle(modalConfirmState.article.id);
          setModalState({ open: false, article: {} });
        }}
      />
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    height: "50px",
    marginTop: "20px",
    boxShadow: "0 2px 3px 0 rgba(0, 0, 0, 0.1)",
    padding: "2px",
  },
  container: {
    height: "100%",
    width: "100%",
  },
  avatarContainer: {
    width: "40px",
    height: "40px",
    margin: "0 10px",
    borderRadius: "50%",
    backgroundColor: "#ccc",
    boxShadow: "0 0 2px 1px #ccc",
    overflow: "hidden",
    backgroundSize: " cover;",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage:
      "url('data:image/jpeg;base64,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')",
  },
  avatar: {
    maxWidth: "100%",
    height: "100%",
    borderRadius: "50%",
  },
  text: {
    textAlign: "center",
    color: "#404040",
    margin: "0 5px",
  },
  title: {
    textAlign: "center",
  },
  deleteIcon: {
    color: "#ccc",
  },
  deleteItem: {
    display: "flex",
    justifyContent: "center",
    // width: "100%",
    marginRight: "20px",
  },
}));
